
function profile(state={
  shareLink: '',
  copySuccess: false,
}, action) {
  switch (action.type) {
    default:
      return state
  }
}

export default profile



// WEBPACK FOOTER //
// ./src/account/profile/reducer.js